import {Component, inject} from '@angular/core';
import {rxResource} from '@angular/core/rxjs-interop';
import {AdminDashboardControllerService} from '@frontend/shared-api';
import {LoadingComponent} from '../../../../shared/components/loading/loading.component';
import {SummaryCardComponent} from '../../../../shared/components/card/summary-card/summary-card.component';

@Component({
  selector: 'app-dashboard-overview',
  templateUrl: './dashboard-overview.component.html',
  imports: [LoadingComponent, SummaryCardComponent],
})
export class DashboardOverviewComponent {
  private readonly adminDashboardController = inject(AdminDashboardControllerService);

  protected readonly dashboardResource = rxResource({
    stream: () => this.adminDashboardController.loadOverview(),
  });
}
